import { render } from "./privacy.vue?vue&type=template&id=769c0dde&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=769c0dde&lang=scss&rel=stylesheet%2Fscss&scoped=true"
script.render = render
script.__scopeId = "data-v-769c0dde"

export default script